import styled, { css } from 'styled-components'

export const CommentTableAuthorContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.space['12']};
  `,
)

export const NameContainer = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
  `,
)

export const CommentContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space[4]};
  `,
)

export const ButtonsContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.space[4]};
  `,
)

export const CircularButton = styled.button<{ $isDanger?: boolean }>(
  ({ theme, $isDanger }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    border: ${theme.border.size['1']} solid ${theme.colors.gray500};
    border-radius: ${theme.border.radius.circle};
    padding: ${theme.space[6]};
    width: ${theme.space[30]};
    height: ${theme.space[30]};
    color: ${$isDanger ? theme.colors.red500 : theme.colors.green500};

    &:hover {
      background-color: ${$isDanger ? theme.colors.red200 : theme.colors.green200};
    }
  `,
)
